import { render, staticRenderFns } from "./TerapiaIntravenosa.vue?vue&type=template&id=874830dc&"
import script from "./TerapiaIntravenosa.vue?vue&type=script&lang=js&"
export * from "./TerapiaIntravenosa.vue?vue&type=script&lang=js&"
import style0 from "./TerapiaIntravenosa.vue?vue&type=style&index=0&id=874830dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports